import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import ActionButton from '../ActionButton'

export const BottomPanel = styled.div<{ isOpen?: boolean }>`
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 0;
  width: 100%;
  max-height: 100vh;
  overflow: auto;
  border-radius: 3rem 3rem 0 0;
  overflow: hidden;
  transform: ${({ isOpen }) => `translateY(${isOpen ? '0' : '100%'})`};
  transition: transform 0.3s ease-in-out;
  background: ${({ theme }) => theme.colors.pureWhite};
  z-index: ${({ theme }) => theme.zIndexes.modal};
  box-shadow: 0 -0.8rem 2.4rem 0 rgba(0, 0, 0, 0.08);
  @media print {
    display: none;
  }
`

export const CloseButton = styled(ActionButton)`
  position: absolute;
  right: 2rem;
`

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  padding: 2.5rem 5.5rem 0 2rem;
  max-width: ${({ theme }) => `${theme.sizes.boxContent / 10}rem`};
  margin: 0 auto 2rem auto;

  @media ${mq(sizes.desktop)} {
    padding: 4rem 0 0 0;
    margin: 0 auto 4rem auto;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  max-width: ${({ theme }) => `${theme.sizes.boxContent / 10}rem`};
  margin: 0 auto;
  padding: 0rem 2rem 0 2rem;

  @media ${mq(sizes.desktop)} {
    padding: 0 16.5rem;
  }
`
